import { appPath } from '@fs/zion-config'
import { getSessionId } from '@fs/zion-session'

export const getURLParams = (search) => {
  if (!search) return {}
  const params = new URLSearchParams(search)
  return Array.from(params).reduce((acc, [key, value]) => {
    acc[key] = value
    return acc
  }, {})
}

export const appendQueryParams = (baseUrl, params) => {
  // Convert params object into array of key-value pairs
  const paramEntries = Object.entries(params)

  // If no params are provided, return the base URL as is
  if (paramEntries.length === 0) return baseUrl

  // Serialize the params into a query string
  const queryString = paramEntries
    .map(([key, value]) => {
      return value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ''
    })
    .join('&')

  // Check if the base URL already contains any query parameters
  if (baseUrl.includes('?')) {
    return `${baseUrl}&${queryString}`
  }

  if (queryString === '') return baseUrl

  return `${baseUrl}?${queryString}`
}

export const getRouteParameterAtIndex = (ind) => {
  const trimmedPath = window.location.href.replace(`${appPath}/`, '')
  const pathSegments = trimmedPath?.split('/')
  const foundRouteParameter = pathSegments?.[ind]?.split(/[?#]/)[0] ?? null // Remove any query string or hash fragment
  return foundRouteParameter
}

export const getDiscoveryOrigin = () => {
  if (process.env.NODE_ENV !== 'development' || !process.env.REACT_APP_DISCOVERY_ORIGIN) return ''
  return new URL(process.env.REACT_APP_DISCOVERY_ORIGIN).origin
}

// Locale-aware absolute path to the Activities tab (e.g. /en/discovery/together/activities).
// Handed to in-app external activities as a `returnTo` param so they can navigate back out.
// appPath is a full absolute URL in served envs; the origin base handles any relative form.
export const getActivitiesReturnUrl = () => {
  const { pathname } = new URL(appPath, window.location.origin)
  const path = `${pathname.replace(/\/$/, '')}/activities`

  return getDiscoveryOrigin() ? `${window.location.origin}${path}` : path
}

export const getActivityListItemDestination = ({ location, activityGroupId, activityGroupAnswerId }) => {
  const pathSegments = [location.pathname]

  if (activityGroupAnswerId) {
    pathSegments.push(activityGroupAnswerId)
  } else if (activityGroupId) {
    pathSegments.push(activityGroupId)
  }

  return pathSegments.join('/') + window.location.search
}

export const addQueryStringVariableToUrl = ({ url, name, value }) => {
  if (!name || !value || !url) return url

  const newUrl = new URL(url)

  newUrl.searchParams.append(name, value)
  return newUrl.toString()
}

export const sessionizeUrl = (url) => {
  return addQueryStringVariableToUrl({ url, name: 'sessionId', value: getSessionId() })
}

export const generateRouteVariants = (prefixes, suffix) => {
  const routes = []
  prefixes.forEach((prefix) => {
    routes.push(`${prefix}${suffix}`)
  })

  return routes
}

// Relative paths that Snow serves with an iframe wrapper (framed-familysearch-page).
// These are marked splash:'external' in data but point to our own server, not a truly external URL.
export const snowFramedPaths = ['/temple/completed']
